import { createLocalStorageStore } from './utils/createLocalStorageStore';

const IDEALIST_ORG_MEMBER_KEY = 'idealistPreSignupOrgMember';

const { useValue, setValue } = createLocalStorageStore<string>({
  key: IDEALIST_ORG_MEMBER_KEY,
});

// Actions

export function setPreSignupOrgMemberOrgId(orgId: string | null) {
  setValue(orgId);
}

// Hooks

export function usePreSignupOrgMember() {
  const value = useValue();
  return { preSignupOrgMemberOrgId: value ?? null };
}
